export const SET_AUTHENTIFICATION = 'SET_AUTHENTIFICATION';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_OF_TO_EDIT = 'SET_OF_TO_EDIT';
export const GET_USER = 'GET_USER';
export const INCREMENT_ACTIONS_COUNT = 'INCREMENT_ACTIONS_COUNT';
export const ADD_RESSOURCE = 'ADD_RESSOURCE';
export const GET_COURS = 'GET_COURS';
export const GET_ATELIER = 'GET_ATELIER';
export const GET_LISTE_PRODUIT = 'GET_LISTE_PRODUIT';
export const GET_STOCK_PRODUIT = 'GET_STOCK_PRODUIT';
export const SET_PRODUIT = 'SET_PRODUIT';
export const GET_LISTE_CLIENT = 'GET_LISTE_CLIENT';
export const GET_TYPE_TRANSPORT = 'GET_TYPE_TRANSPORT';
export const GET_LISTE_METAUX = 'GET_LISTE_METAUX';
// Nouvelle table metal (différente de type_metal)
export const GET_LISTE_METAL = 'GET_LISTE_METAL';
export const GET_LISTE_STADE = 'GET_LISTE_STADE';
export const GET_LISTE_TYPE_PRODUIT = 'GET_LISTE_TYPE_PRODUIT';
export const GET_LISTE_STATUT = 'GET_LISTE_STATUT';
export const GET_LISTE_JOAILLIER = 'GET_LISTE_JOAILLIER';
export const GET_LISTE_ATELIER = 'GET_LISTE_ATELIER';
export const GET_LISTE_BOITE_OR = 'GET_LISTE_BOITE_OR';
export const GET_LISTE_SERTISSEUR = 'GET_LISTE_SERTISSEUR';
export const GET_LISTE_FOURNISSEUR = 'GET_LISTE_FOURNISSEUR';
export const GET_LISTE_OF_SERTI = 'GET_LISTE_OF_SERTI';
export const GET_LISTE_PIERRE = 'GET_LISTE_PIERRE';
export const GET_LISTE_TYPE_PIERRE = 'GET_LISTE_TYPE_PIERRE';
export const GET_LISTE_FORME_PIERRE = 'GET_LISTE_FORME_PIERRE';
export const GET_LISTE_COULEUR_PIERRE = 'GET_LISTE_COULEUR_PIERRE';
export const GET_LISTE_QUALITE_PIERRE = 'GET_LISTE_QUALITE_PIERRE';
export const GET_LISTE_CONFIE_PIERRE = 'GET_LISTE_CONFIE_PIERRE';
export const GET_LISTE_RETOUR_PIERRE = 'GET_LISTE_RETOUR_PIERRE';
export const GET_LISTE_ETAT_PIERRE = 'GET_LISTE_ETAT_PIERRE';
export const GET_TYPE_COM = 'GET_TYPE_COM';
export const GET_TYPE_TVA = 'GET_TYPE_TVA';
export const GET_TYPE_COMMANDE = 'GET_TYPE_COMMANDE';
export const GET_LISTE_AVOIR = 'GET_LISTE_AVOIR';
export const GET_LISTE_IMAGE = 'GET_LISTE_IMAGE';


export const ADD_OF = 'ADD_OF';
export const UPDATE_OF = 'UPDATE_OF';
export const DELETE_OF = 'DELETE_OF';
export const DELETE_OFS = 'DELETE_OFS';
export const GET_OFS = 'GET_OFS';
export const GET_OFS_FACTURATION = 'GET_OFS_FACTURATION';
export const GET_OF_FROM_ID = 'GET_OF_FROM_ID';
export const ADD_OF_TO_FACT = 'ADD_OF_TO_FACT';
export const DELETE_OF_TO_FACT = 'DELETE_OF_TO_FACT';
export const GET_OF_EN_COURS = 'GET_OF_EN_COURS';
export const GET_OF_LIVRE = 'GET_OF_LIVRE';
export const GET_OF_LIVRE_EXTENSIA = 'GET_OF_LIVRE_EXTENSIA';
export const GET_TYPE_TARIF = 'GET_TYPE_TARIF';
export const GET_CA_GROUPED_BY_MONTH = 'GET_CA_GROUPED_BY_MONTH';
export const GET_COMPARAION_CA_GROUPED_BY_MONTH = 'GET_COMPARAION_CA_GROUPED_BY_MONTH';
export const GET_COMPARAION_CA_GROUPED_BY_YEAR = 'GET_COMPARAION_CA_GROUPED_BY_YEAR';
export const GET_ANALYSE_CA = 'GET_ANALYSE_CA';
export const GET_ANALYSE_TRANCHE = 'GET_ANALYSE_TRANCHE';
export const GET_ANALYSE_CA_TARIF = 'GET_ANALYSE_CA_TARIF';
export const GET_ANALYSE_METAL = 'GET_ANALYSE_METAL';
export const GET_ANALYSE_FOURNISSEUR = 'GET_ANALYSE_FOURNISSEUR';
export const SET_TARIF_PRODUIT = 'SET_TARIF_PRODUIT';

// Mouvements Or CRUD
export const GET_MOUVEMENTS_OR = 'GET_MOUVEMENTS_OR';
export const ADD_MOUVEMENT_OR = 'ADD_MOUVEMENT_OR';
export const UPDATE_MOUVEMENT_OR = 'UPDATE_MOUVEMENT_OR';
export const DELETE_MOUVEMENT_OR = 'DELETE_MOUVEMENT_OR';

// Mouvements Or Clients (backend séparé)
export const GET_MOUVEMENTS_OR_CLIENT = 'GET_MOUVEMENTS_OR_CLIENT';
export const DELETE_MOUVEMENT_OR_CLIENT = 'DELETE_MOUVEMENT_OR_CLIENT';

// Mouvements CLAL (agrégé externe)
export const GET_MOUVEMENTS_CLAL = 'GET_MOUVEMENTS_CLAL';
export const ADD_MOUVEMENT_CLAL = 'ADD_MOUVEMENT_CLAL';
export const UPDATE_MOUVEMENT_CLAL = 'UPDATE_MOUVEMENT_CLAL';
export const DELETE_MOUVEMENT_CLAL = 'DELETE_MOUVEMENT_CLAL';




// Contenants (atelier)
export const GET_CONTENANTS = 'GET_CONTENANTS';
export const ADD_CONTENANT = 'ADD_CONTENANT';
export const UPDATE_CONTENANT = 'UPDATE_CONTENANT';
export const DELETE_CONTENANT = 'DELETE_CONTENANT';

// Pesées (atelier)
export const GET_PESEES = 'GET_PESEES';
export const ADD_PESEE = 'ADD_PESEE';
export const UPDATE_PESEE = 'UPDATE_PESEE';
export const DELETE_PESEE = 'DELETE_PESEE';

// Analyse Marges
export const GET_ANALYSE_MARGE_TOTAUX = 'GET_ANALYSE_MARGE_TOTAUX';
export const GET_ANALYSE_MARGE_CLASSES = 'GET_ANALYSE_MARGE_CLASSES';
export const GET_ANALYSE_MARGE_DETAILS = 'GET_ANALYSE_MARGE_DETAILS';
export const GET_ANALYSE_MARGE_EFFICACITE = 'GET_ANALYSE_MARGE_EFFICACITE';

// Analyse Marges Livrées
export const GET_ANALYSE_MARGE_TOTAUX_LIVRES = 'GET_ANALYSE_MARGE_TOTAUX_LIVRES';
export const GET_ANALYSE_MARGE_CLASSES_LIVRES = 'GET_ANALYSE_MARGE_CLASSES_LIVRES';
export const GET_ANALYSE_MARGE_DETAILS_LIVRES = 'GET_ANALYSE_MARGE_DETAILS_LIVRES';
export const GET_ANALYSE_MARGE_EFFICACITE_LIVRES = 'GET_ANALYSE_MARGE_EFFICACITE_LIVRES';

// Compte Poids Clients (mock front)
export const COMPTE_POIDS_LOAD_REQUEST = 'COMPTE_POIDS_LOAD_REQUEST';
export const COMPTE_POIDS_LOAD_SUCCESS = 'COMPTE_POIDS_LOAD_SUCCESS';
export const COMPTE_POIDS_LOAD_FAILURE = 'COMPTE_POIDS_LOAD_FAILURE';
export const COMPTE_POIDS_SET_FILTER = 'COMPTE_POIDS_SET_FILTER';
export const COMPTE_POIDS_SET_DATE_RANGE = 'COMPTE_POIDS_SET_DATE_RANGE';
export const COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_REQUEST = 'COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_REQUEST';
export const COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_SUCCESS = 'COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_SUCCESS';
export const COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_FAILURE = 'COMPTE_POIDS_CREATE_ENTREE_BROUTILLE_FAILURE';
export const COMPTE_POIDS_CREATE_RETOUR_AVOIR_REQUEST = 'COMPTE_POIDS_CREATE_RETOUR_AVOIR_REQUEST';
export const COMPTE_POIDS_CREATE_RETOUR_AVOIR_SUCCESS = 'COMPTE_POIDS_CREATE_RETOUR_AVOIR_SUCCESS';
export const COMPTE_POIDS_CREATE_RETOUR_AVOIR_FAILURE = 'COMPTE_POIDS_CREATE_RETOUR_AVOIR_FAILURE';
export const COMPTE_POIDS_CLEAR_ERROR = 'COMPTE_POIDS_CLEAR_ERROR';

// Devis
export const GET_LISTE_DEVIS   = 'GET_LISTE_DEVIS';
export const ADD_DEVIS         = 'ADD_DEVIS';
export const UPDATE_DEVIS      = 'UPDATE_DEVIS';
export const DELETE_DEVIS      = 'DELETE_DEVIS';

// Relevé d'heures (commercial)
export const RELEVE_HEURES_SET_WEEK = 'RELEVE_HEURES_SET_WEEK';
export const RELEVE_HEURES_SET_EXPANDED_DAY = 'RELEVE_HEURES_SET_EXPANDED_DAY';
export const RELEVE_HEURES_SET_CHAMP = 'RELEVE_HEURES_SET_CHAMP';
export const RELEVE_HEURES_SET_JOURNEE = 'RELEVE_HEURES_SET_JOURNEE';
export const RELEVE_HEURES_SET_META = 'RELEVE_HEURES_SET_META';
export const RELEVE_HEURES_LOAD_REQUEST = 'RELEVE_HEURES_LOAD_REQUEST';
export const RELEVE_HEURES_LOAD_SUCCESS = 'RELEVE_HEURES_LOAD_SUCCESS';
export const RELEVE_HEURES_LOAD_FAILURE = 'RELEVE_HEURES_LOAD_FAILURE';
export const RELEVE_HEURES_SAVE_REQUEST = 'RELEVE_HEURES_SAVE_REQUEST';
export const RELEVE_HEURES_SAVE_SUCCESS = 'RELEVE_HEURES_SAVE_SUCCESS';
export const RELEVE_HEURES_SAVE_FAILURE = 'RELEVE_HEURES_SAVE_FAILURE';




